import { configFonts } from "./configFonts";
import { getTheming } from "./getTheming";
import type { ConfigTheming, ThemeType, Theming } from "./types";

export const applyTheming = (
	configTheming: ConfigTheming,
	partnerCode: string,
	cdnUrl: string,
	theme?: ThemeType,
): Theming => {
	const theming = getTheming(configTheming, partnerCode, cdnUrl, theme);
	configFonts(cdnUrl, theming.primaryFonts, theming.secondaryFonts);
	return theming;
};
